import { defaultCustomerState } from '../../models/redux/DefaultCustomerState';
import {
  CLEAR_CUSTOMER_DATA,
  FETCH_ABSENCE_ERROR,
  FETCH_ABSENCE_RECEIVE,
  FETCH_ABSENCE_REQUEST,
  FETCH_MEMOS_RECEIVE,
  FETCH_MEMOS_REQUEST,
  GET_MY_CUSTOMERS_ERROR,
  GET_MY_CUSTOMERS_RECEIVE,
  GET_MY_CUSTOMERS_REQUEST,
  POST_ABSENCE_REQUEST
} from './types';

const CustomerReducer = (state = defaultCustomerState, action: any) => {
  switch (action.type) {
    case FETCH_ABSENCE_REQUEST: {
      state = {
        ...state,
        absenceLoading: true,
        absence: []
      };
      break;
    }
    case FETCH_ABSENCE_RECEIVE: {
      state = {
        ...state,
        absenceLoading: false,
        absence: action.payload
      };
      break;
    }
    case FETCH_ABSENCE_ERROR: {
      state = {
        ...state,
        absenceLoading: false
      };
      break;
    }
    case GET_MY_CUSTOMERS_REQUEST: {
      state = {
        ...state,
        myCustomers: [],
        myCustomersLoading: true
      };
      break;
    }
    case GET_MY_CUSTOMERS_RECEIVE: {
      state = {
        ...state,
        myCustomersLoading: false,
        myCustomers: action.payload
      };
      break;
    }
    case GET_MY_CUSTOMERS_ERROR: {
      state = {
        ...state,
        myCustomersLoading: false
      };
      break;
    }
    case POST_ABSENCE_REQUEST: {
      state = {
        ...state,
        absenceLoading: true
      };
      break;
    }
    case FETCH_MEMOS_REQUEST: {
      state = {
        ...state,
        memosLoading: true,
        memos: []
      };
      break;
    }
    case FETCH_MEMOS_RECEIVE: {
      state = {
        ...state,
        memosLoading: false,
        memos: action.payload
      };
      break;
    }
    case CLEAR_CUSTOMER_DATA: {
      state = {
        ...state,
        absenceLoading: false,
        absence: [],
        memosLoading: false,
        memos: []
      };
      break;
    }
  }

  return state;
};

export { CustomerReducer };
